export interface ApplicationApiUrls {
    v3BaseApiUrl?: string;
    authBaseUrl?: string;
    authbaseUrl?: string;
    digitalWalletBaseApiUrl?: string;
}

export type ApplicationApi = 'members' | 'auth' | 'wallet';

export function getApplicationApi(url: string, environment: ApplicationApiUrls): ApplicationApi | null {
    let target: URL;
    try {
        target = new URL(url, window.location.origin);
    } catch {
        return null;
    }

    const bases: [ApplicationApi, string | undefined][] = [
        ['auth', environment.authBaseUrl || environment.authbaseUrl],
        ['members', environment.v3BaseApiUrl],
        ['wallet', environment.digitalWalletBaseApiUrl],
    ];
    for (const [api, baseUrl] of bases) {
        if (!baseUrl) {
            continue;
        }

        let base: URL;
        try {
            base = new URL(baseUrl, window.location.origin);
        } catch {
            continue;
        }

        const path = base.pathname.replace(/\/+$/, '');
        if (target.origin === base.origin &&
            (target.pathname === path || target.pathname.startsWith(`${path}/`))) {
            return api;
        }
    }

    return null;
}
